// extracted by mini-css-extract-plugin
export var container = "_gs-1";
export var cornerButtonContainer = "_gs-6";
export var disabled = "_gs-2";
export var dragActive = "_gs-3";
export var fileContainer = "_gs-5";
export var hiddenInput = "_gs-4";
export var widthContainer = "_gs-0";